define('shoptheme/components/product/view/media',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"modernizr",
	"elevatezoom",
	"cartware-slider",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	BEM
) {
	var cache = {
		galleries: {}
	};

	return Component.create({
		block:			null,
		thumbs:			null,
		galleryImages:	null,
		galleryElement:	null,

		$init: function() {
			this.initializeComponent();
			this.initializeSimpleObservation();
			cache.galleries["__initial"] = this.block;
		},

		initializeComponent: function() {
			this.block = BEM.block("product-media");

			this.galleryImages = this.block.getElements("gallery-image");

			this.initializeThumbnails();
			this.createZoom(this.galleryImages.filter(":modifier(visible)"));
		},

		initializeThumbnails: function() {
			this.thumbs = this.block.getElements("more-views-thumb-link");

			this.thumbs.each(function(i) {
				$(this).data("image-index", i);
			});

			this.thumbs.on("click", _.bind(this._onThumbnailClick, this));
		},

		initializeSimpleObservation: function() {
			var currentSimple = ("undefined" !== typeof spConfig) ? _.get(spConfig, "__currentGallerySimple") : null;

			var _onChangeGallerySimple = _.bind(function(e, simple) {
				this.changeSimple(simple);
			}, this);

			$(document).on('product/changeGallerySimple', _onChangeGallerySimple);

			if (currentSimple) {
				_onChangeGallerySimple(null, currentSimple);
			}
		},

		changeSimple: function(simple) {
			var block,
				wrap = $("<div />").css("min-height", this.block.outerHeight(true)),
				self = this;

			if (!(simple.id in cache.galleries)) {
				cache.galleries[simple.id] = $(simple.mediaGallery);
			}

			block = cache.galleries[simple.id];

			$('.zoomContainer').remove();

			this.block.wrap(wrap);

			//this.block.replaceWith(block);
			block.replaceAll(this.block);
			this.initializeComponent();

			var sliderBlock = this.block.find(".cartware-slider");

			if (sliderBlock.length) {
				sliderBlock.cartwareSlider()
					.data('cartware_slider/instance')
					.on("ready", function() {
						self.block.unwrap();
					});
			}
		},

		_onThumbnailClick: function(e) {
			var thumb = $(e.currentTarget),
				image = thumb.data("media-gallery-image");

			if (!image) {
				image = $("#image-" + thumb.data("image-index"));
				thumb.data("media-gallery-image", image);
			}

			e.preventDefault();

			this.destroyZoom();

			this.galleryImages.filter(":modifier(visible)")
				.bemRemoveModifier("visible");

			image.bemAddModifier("visible");
			this.createZoom(image);
		},

		createZoom: function(image) {
			var self = this;

			if (!Modernizr.touch) {
				image.elevateZoom({
					zoomType: "inner",
					responsive: true
				});
			}

			image.on("click", function(e) {
				var items = [],
					index = 0,
					imageSrc = image.attr("src");

				if ($.magnificPopup.instance.isOpen) {
					return;
				}

				self.galleryImages.each(function(i) {
					var src = $(this).attr("src");

					if (i > 0) { // skip default image
						items.push({
							src: src
						});

						if (index === 0 && src == imageSrc) {
							index = i - 1;
						}
					}
				});

				$.magnificPopup.open({
					items: items,
					type: "image",
					gallery: {
						enabled: true
					}
				}, index);
			});
		},

		destroyZoom: function() {
			$('.zoomContainer').remove();
			this.galleryImages.filter(":modifier(visible)")
				.removeData('elevateZoom');
		}
	});
});
